export default __webpack_public_path__ + "static/media/monitor-icon.0eabd48e.png";